import { useTheme, GlobalStyles as MUIGlobalStyles } from "@mui/material";
import { grey } from "@mui/material/colors";
import { useContext, useMemo } from "react";
import { EditorCtx } from "../wysiwyg/EditorCtx";

export const GlobalStyles = () => {
  const theme = useTheme();
  const { liveConfig } = useContext(EditorCtx);
  const style = useMemo(
    () => (
      <MUIGlobalStyles
        styles={{
          "*": {
            margin: 0,
            padding: 0,
            boxSizing: "border-box",
          },

          "html, body, #root, #__next": {
            height: "100%",
            minHeight: "300px",
          },

          "::-webkit-scrollbar-track": {
            background: "none",
          },

          "::-webkit-scrollbar-thumb": {
            background: grey[300],
            borderRadius: "1rem",
          },

          "::-webkit-scrollbar-thumb:hover": {
            background: grey[300],
          },
        }}
      />
    ),
    [theme, liveConfig],
  );
  return style;
};
